import Link from 'next/link';
import { useEffect, useState } from 'react';
import eventClickCategory from 'ui/lib/gtm/eventClickCategory';
import { useRouter } from '../../../hooks/useCustomRouter';

interface ITabsPromoProps {
  tabs: {
    name: string;
    path: string;
  }[];
  children: React.ReactNode;
  className?: string;
}

const TabsPromo = ({ tabs, children, className }: ITabsPromoProps) => {
  const router = useRouter();

  const [category, setCategory] = useState(router?.query?.kategori || '');

  const PUBLIC_URL = process.env.NEXT_PUBLIC_BASEPATH_URL;

  useEffect(() => {
    setCategory(router?.query?.kategori || '');
  }, [router?.query]);

  const handleCategoryClick = (newCategory) => {
    setCategory(newCategory);
    eventClickCategory(newCategory || 'semua');
  };

  return (
    <>
      <div
        className={`${className} flex items-center justify-start w-full bg-white overflow-x-auto no-scrollbar`}
      >
        {tabs.map((tab, index) => (
          <Link
            key={index}
            href={`${PUBLIC_URL}${tab.path.toLowerCase()}`}
            onClick={() => handleCategoryClick(tab.name === 'SEMUA' ? '' : tab.name)}
            className={`inline-block text-xs uppercase text-reliableBlack whitespace-nowrap py-3.5 px-4 border-b-4 lg:text-base lg:py-4 lg:px-5 lg:border-b-[3px] hover:border-supportiveRed ${
              category === '' && tab.name === 'SEMUA'
                ? 'font-bold border-supportiveRed'
                : (category as string).split('-').join(' ') === tab.name.toLowerCase()
                  ? 'font-bold border-supportiveRed'
                  : 'border-transparent'
            }`}
          >
            {tab.name.toUpperCase()}
          </Link>
        ))}
      </div>

      <div>{children}</div>
    </>
  );
};

export default TabsPromo;
